export enum DonorType {    
    DirectedDonor = 1,
    NonDirectedDonor = 2
}